import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrolls to the top on navigation, or to the `#hash` target once the page has
 * rendered (menu entries such as /about#vision rely on this).
 */
export function useScrollToAnchor() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0)
      return undefined
    }

    const frame = window.requestAnimationFrame(() => {
      const target = document.getElementById(hash.slice(1))
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        window.scrollTo(0, 0)
      }
    })

    return () => window.cancelAnimationFrame(frame)
  }, [pathname, hash])
}
